import mod from "-!./OpenCall.js?vue&type=script&lang=js&"; export default mod; export * from "-!./OpenCall.js?vue&type=script&lang=js&"